'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _styles = require('@material-ui/core/styles');

var _RatingChipGroup = require('./RatingChipGroup');

var _RatingChipGroup2 = _interopRequireDefault(_RatingChipGroup);

var _core = require('@manakin/core');

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Grid = require('@material-ui/core/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _appCore = require('@manakin/app-core');

var _Typography = require('@material-ui/core/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _graphql = require('./graphql');

var _reactHooks = require('@apollo/react-hooks');

var _actions = require('@manakin/core/actions');

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
	var _root;

	return {
		root: (_root = {
			padding: '0 25px'
		}, _defineProperty(_root, theme.breakpoints.up('md'), {
			padding: '0 6rem'
		}), _defineProperty(_root, theme.breakpoints.up('lg'), {
			padding: '0 15rem'
		}), _root),
		contentFirst: _defineProperty({}, theme.breakpoints.up('md'), {
			paddingRight: '50px'
		}),
		contentSecond: _defineProperty({}, theme.breakpoints.up('md'), {
			paddingLeft: '50px'
		}),
		contentTrainerAndDate: _defineProperty({
			display: 'flex',
			flexDirection: 'row',
			'& > div': {
				flexGrow: 1
			}
		}, theme.breakpoints.down('md'), {
			flexDirection: 'column'
		}),
		contentColor: {},
		header: {
			color: '#BFBFBF',
			marginBottom: 0,
			marginTop: theme.spacing(4)
		},
		text: {
			marginBottom: 0
		},
		subHeader: {},
		button: {
			textAlign: 'left',
			justifyContent: 'start',
			marginTop: theme.spacing(4)
		},
		longArrowRoot: {
			marginLeft: 'auto',
			marginRight: theme.spacing(1)
		},
		explanation: {
			marginTop: 0,
			'label + &': {
				marginTop: 0
			}
		},
		ratingTitle: {
			marginBottom: '10px'
		}
	};
};

var formBundle = {
	ranking: {
		required: true
	},
	explanation: {
		required: true
	}
};

var RatingRespondTab = function RatingRespondTab(props) {
	var classes = props.classes,
	    ratingRequest = props.ratingRequest,
	    form = props.form,
	    appUser = props.appUser,
	    studentId = props.studentId,
	    defaultReadOnly = props.readOnly;


	var dispatch = (0, _reactRedux.useDispatch)();
	var signatureRef = (0, _react.useRef)();
	var readOnly = defaultReadOnly;
	var signatureReadOnly = ratingRequest && ratingRequest.result && ratingRequest.result.signature && ratingRequest.result.signature.url || defaultReadOnly;

	var _useTranslation = (0, _reactI18next.useTranslation)(),
	    t = _useTranslation.t;

	(0, _react.useEffect)(function () {
		if (ratingRequest && ratingRequest.result) {
			form.onFieldChange({
				key: 'ranking',
				value: ratingRequest.result.ranking
			});
			form.onFieldChange({
				key: 'explanation',
				value: ratingRequest.result.explanation
			});
		}
	}, [ratingRequest]);

	// Mutations

	var _useMutation = (0, _reactHooks.useMutation)(_graphql.GQL_SEND_RATING_REQUEST_RESPONSE),
	    _useMutation2 = _slicedToArray(_useMutation, 2),
	    ratingRequestRespond = _useMutation2[0],
	    _useMutation2$ = _useMutation2[1],
	    ratingRequestRespondData = _useMutation2$.data,
	    ratingRequestRespondError = _useMutation2$.error;

	var _useMutation3 = (0, _reactHooks.useMutation)(_graphql.GQL_CREATE_ELEMENT_RESULT),
	    _useMutation4 = _slicedToArray(_useMutation3, 1),
	    createElementResult = _useMutation4[0];

	var _useMutation5 = (0, _reactHooks.useMutation)(_graphql.GQL_UPLOAD_ASSET),
	    _useMutation6 = _slicedToArray(_useMutation5, 1),
	    uploadAsset = _useMutation6[0];

	var handleSubmit = function () {
		var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
			var onSubmit;
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							onSubmit = form.onSubmit;

							form.onValidate().then(function () {
								return onSubmit().then(function () {
									var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
										var signatureUploadedAssetId;
										return regeneratorRuntime.wrap(function _callee$(_context) {
											while (1) {
												switch (_context.prev = _context.next) {
													case 0:
														signatureUploadedAssetId = undefined;

														if (signatureReadOnly) {
															_context.next = 20;
															break;
														}

														_context.next = 4;
														return noSignatureUsed();

													case 4:
														if (!_context.sent) {
															_context.next = 6;
															break;
														}

														return _context.abrupt('return', dispatch((0, _actions.showSnackbarMessage)({
															text: t('app.rating-request.respond.tab.no-signature-set'),
															variant: 'error'
														})));

													case 6:
														_context.t0 = uploadAsset;
														_context.next = 9;
														return signatureRef.current.getImageAsPng().then(function (file) {
															return file;
														});

													case 9:
														_context.t1 = _context.sent;
														_context.t2 = {
															file: _context.t1
														};
														_context.t3 = {
															hasUpload: true
														};
														_context.t4 = {
															variables: _context.t2,
															context: _context.t3
														};

														_context.t5 = function (result) {
															return result.data && result.data.uploadAsset && result.data.uploadAsset.asset && result.data.uploadAsset.asset.id;
														};

														_context.t6 = function (e) {
															return false;
														};

														_context.next = 17;
														return (0, _context.t0)(_context.t4).then(_context.t5).catch(_context.t6);

													case 17:
														signatureUploadedAssetId = _context.sent;

														if (signatureUploadedAssetId) {
															_context.next = 20;
															break;
														}

														return _context.abrupt('return', dispatch((0, _actions.showSnackbarMessage)({
															text: t('app.rating-request.respond.tab.signature-failed'),
															variant: 'error'
														})));

													case 20:

														ratingRequestRespond({
															variables: _extends({
																ratingRequestId: ratingRequest.id,
																ranking: data.ranking
															}, signatureUploadedAssetId && {
																signatureAssetId: signatureUploadedAssetId
															}, {
																explanation: data.explanation
															})
														});

														if (studentId && signatureUploadedAssetId) {
															createElementResult({
																variables: {
																	user: studentId,
																	program: props.program,
																	box: props.boxId,
																	element: props.elementId,
																	ratingTeacher: 'RATED'
																}
															}).catch(function (e) {
																return console.log('e', e);
															});
														}

													case 22:
													case 'end':
														return _context.stop();
												}
											}
										}, _callee, undefined);
									}));

									return function (_x) {
										return _ref2.apply(this, arguments);
									};
								}());
							}, function (error) {
								// Handled by inputs
								onError();
							});

						case 2:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function handleSubmit() {
			return _ref.apply(this, arguments);
		};
	}();

	var noSignatureUsed = function () {
		var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.t0 = !signatureRef.current || signatureRef.current.isEmpty();

							if (_context3.t0) {
								_context3.next = 6;
								break;
							}

							_context3.next = 4;
							return signatureRef.current.getImageAsSvg().length;

						case 4:
							_context3.t1 = _context3.sent;
							_context3.t0 = _context3.t1 < 500;

						case 6:
							return _context3.abrupt('return', _context3.t0);

						case 7:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function noSignatureUsed() {
			return _ref3.apply(this, arguments);
		};
	}();

	var onSucces = (0, _react.useCallback)(function () {
		return dispatch((0, _actions.showSnackbarMessage)({
			text: t('app.rating-request.respond.tab.save-success'),
			variant: 'success'
		}));
	}, [dispatch]);

	var onError = (0, _react.useCallback)(function () {
		return dispatch((0, _actions.showSnackbarMessage)({
			text: t('app.rating-request.respond.tab.save-failed'),
			variant: 'error'
		}));
	}, [dispatch]);

	(0, _react.useEffect)(function () {
		var handleResponse = function () {
			var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
				var noSignature;
				return regeneratorRuntime.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.next = 2;
								return noSignatureUsed();

							case 2:
								noSignature = _context4.sent;


								if (ratingRequestRespondData && ratingRequestRespondData.addResultToRatingRequest && ratingRequestRespondData.addResultToRatingRequest.ratingRequest) {
									setTimeout(function () {
										onSucces();
										form.clear();
										if (props.onSuccess) props.onSuccess();
									}, noSignature ? 2500 : 0);
								}

								if (ratingRequestRespondError) {
									setTimeout(function () {
										onError();
									}, noSignature ? 2500 : 0);
								}

							case 5:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, undefined);
			}));

			return function handleResponse() {
				return _ref4.apply(this, arguments);
			};
		}();
		handleResponse();
	}, [ratingRequestRespondData, ratingRequestRespondError]);

	// The signature field won't render correctly if it is not being displayed, only display when active
	if (!props.active) return _react2.default.createElement('div', null);

	return _react2.default.createElement(
		_Grid2.default,
		{ container: true, spacing: 2, className: classes.root },
		_react2.default.createElement(
			_Grid2.default,
			_extends({ item: true }, { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }),
			_react2.default.createElement(
				'div',
				{ className: classes.contentFirst },
				_react2.default.createElement(
					_Typography2.default,
					{
						component: 'div',
						variant: 'body1',
						className: (0, _classnames2.default)(classes.contentColor, classes.header, classes.subHeader, classes.ratingTitle)
					},
					t('app.rating-request.respond.tab.title')
				),
				_react2.default.createElement(_RatingChipGroup2.default, {
					form: form,
					readOnly: readOnly,
					initialValue: ratingRequest && ratingRequest.result && ratingRequest.result.ranking,
					name: 'ranking'
				}),
				_react2.default.createElement(
					'div',
					{ className: classes.contentTrainerAndDate },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_Typography2.default,
							{
								component: 'div',
								variant: 'body1',
								className: (0, _classnames2.default)(classes.contentColor, classes.header, classes.subHeader)
							},
							t('common.trainer')
						),
						_react2.default.createElement(
							_Typography2.default,
							{
								component: 'div',
								variant: 'body1',
								className: (0, _classnames2.default)(classes.contentColor, classes.subHeader, classes.text)
							},
							ratingRequest && ratingRequest.trainer && ratingRequest.trainer.fullName || appUser.fullName
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							_Typography2.default,
							{
								component: 'div',
								variant: 'body1',
								className: (0, _classnames2.default)(classes.contentColor, classes.header, classes.subHeader)
							},
							t('common.date')
						),
						_react2.default.createElement(
							_Typography2.default,
							{
								component: 'div',
								variant: 'body1',
								className: (0, _classnames2.default)(classes.contentColor, classes.subHeader, classes.text)
							},
							(0, _moment2.default)(ratingRequest && ratingRequest.result && ratingRequest.result.gradedAt || new Date()).locale(t('common.locale-code')).format('D MMMM YYYY')
						)
					)
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_Typography2.default,
						{
							component: 'div',
							variant: 'body1',
							className: (0, _classnames2.default)(classes.contentColor, classes.header, classes.subHeader)
						},
						t('common.explanation')
					),
					_react2.default.createElement(_core.SpeechField, {
						name: 'explanation',
						label: '',
						readOnly: readOnly,
						form: form,
						initialValue: ratingRequest && ratingRequest.result && ratingRequest.result.explanation,
						placeholder: t('common.fields.explanation.placeholder'),
						className: classes.explanation,
						inputClassName: classes.explanation
					})
				)
			)
		),
		_react2.default.createElement(
			_Grid2.default,
			_extends({ item: true }, { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }),
			_react2.default.createElement(
				'div',
				{ className: classes.contentSecond },
				_react2.default.createElement(
					_Typography2.default,
					{
						component: 'div',
						variant: 'body1',
						className: (0, _classnames2.default)(classes.contentColor, classes.header, classes.subHeader)
					},
					t('common.signature'),
					' *'
				),
				_react2.default.createElement(_appCore.SignatureField, {
					readOnly: signatureReadOnly,
					value: ratingRequest && ratingRequest.result && ratingRequest.result.signature && ratingRequest.result.signature.url,
					ref: signatureRef
				}),
				!readOnly && _react2.default.createElement(
					_Button2.default,
					{
						variant: 'contained',
						color: 'primary',
						fullWidth: true,
						className: (0, _classnames2.default)(classes.button),
						onClick: handleSubmit,
						disabled: false
					},
					t('app.rating-request.respond.tab.save-action'),
					_react2.default.createElement(_appCore.LongArrow, { className: classes.longArrowRoot })
				)
			)
		)
	);
};

exports.default = (0, _recompose.compose)((0, _styles.withStyles)(styles, { name: 'AppStudentRating' }), (0, _core.withForm)(formBundle))(RatingRespondTab);